<template functional>
  <fieldset class="radios">
    <legend>
      <slot />
    </legend>
    <div class="radio">
      <label
        v-for="(label, key) of props.choices"
        :key="key"
      >
        <input
          type="radio"
          :name="props.name"
          :value="key"
          :checked="props.value == key"
          @change="listeners.input(props.type == Number ? parseInt($event.target.value) : $event.target.value)"
        >
        <span class="toggle" />
        <span>{{ parent.t(label) }}</span>
      </label>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    choices: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.radios {
  flex: 0 0 100%;
  border: none;
  margin: 0;
  padding: 0;
}

legend {
  /* hide it until we need it */
  display: none;
}

.radio {
  display: flex;
  flex-wrap: wrap;

  label {
    flex: 1 0 auto;
    width: 33.33%;
    max-width: 33.33%;
    display: flex;

    input {
      display: none;

      &:checked + .toggle {
        border-width: 3px;
        background-color: darken($color-main, 5);
      }
    }

    .toggle {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 2px #fff solid;
      background-color: transparent;
      transition: all 250ms ease-in-out;
      margin-right: 10px;
      margin-top: 2px;
      border-radius: 50%;
    }

    &:hover {
      cursor: pointer;

      .toggle {
        background-color: #fff;
      }
    }
  }
}
</style>
